module.exports = __webpack_public_path__ + "media/assets/faria_products/OSC Study App-098beafc0aaba21f969ee8334bff0c5120824bed24c8aefc535a06cde9cc12ae.png";